import { observer } from 'mobx-react';
import React, { SyntheticEvent, useEffect, useRef, useState } from 'react';
import toast from 'react-hot-toast';
import { FormattedMessage } from 'react-intl';
import SlidingPanel from 'react-sliding-side-panel';
import noMessageIcon from '../../assets/Images/no-dimension-table.png';
import { ModuleType } from '../../constants/enums/module-type-enum';
import userSettingEnum from '../../constants/enums/user-setting-enum';
import { useStore } from '../../contexts/store-provider';
import {
  ProcessDefaultSortColumnOrder,
  ProcessFilterInitialState,
} from '../../core/initialState/filter-initial-state';
import {
  isOperationPermittedRoleBase,
  showIconsRoleBase,
} from '../../helpers/action-permission-helper';
import IPageInfo, {
  IActionFormatter,
  IPageLimitInfo,
} from '../../models/ICommon';
import IDefaultColumSortOrder from '../../models/IDefaultColumSortOrder';
import { IProcessFilter } from '../../models/IProcessFilter';
import FormLoader from '../../shared-components/FormLoader/FormLoader';
import Grid from '../../shared-components/Grid/Grid';
import { CustomActionFormatter } from '../../shared-components/Grid/GridFormatter';
import Pagination from '../../shared-components/Grid/Pagination';
import FilterPopupHOC from '../../shared-components/hoc/filter-popup-hoc/filter-popup-hoc';
import DeletePopup from '../../shared-components/popup/delete/delete-popup';
import DeletePopupHOC from '../../shared-components/popup/delete/delete-popup-hoc';
import {
  CloseSidePanelIcon,
  DeleteIcon,
  EditIcon,
  PlusIcon,
  RefreshIcon,
} from '../../shared-components/svgs/svgs';
import { formatMessage } from '../../translations/format-message';
import FilterComponent from './components/filter';
import './dimension-table-fields.css';
import AddDimensionDataPopupHOC from './hoc/add-dimension-data-popup-hoc';
import AddDimensionData from './components/add-edit-dimension-data-columns';
import { getTenantIdFromLocalStorage } from '../../helpers/localstorage-helper';
import Header from '../../shared-components/header/header';
import ReorderProcess from '../../assets/Images/reorderProcess.svg';
import DimensionDetails from './dimension-details';
import ProcessReorder from '../active-tray-mgmt/components/process-reorder';
import ReorderProcessPopupHOC from '../active-tray-mgmt/hoc/reorder-process-popup-hoc';
import activeTrayManagementStore from '../../core/stores/active-tray-management-store';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

const DimensionTableFields = (props: any) => {
  const { processStore, preferencesStore, dimensionStore } = useStore();
  const {
    GetProcessListService,
    allProcess,
    // processList,
    deleteProcessState,
    DeleteProcessService,
    resetDeleteProcess,
    resetProcessDetail,
    addUpdateProcessState,
    resetAddUpdateProcessState,
    processState,
    getAllProcessState,
    saveDimensionDataState,
    resetSaveDimensionDataState,
  } = processStore;

  const {
    userSetting,
    setUserSetting,
    language,
    islanguageChanged,
    updateLanguageChangedFlag,
  } = preferencesStore;

  const {
    allDimension,
    GetDimensionListService,
    getDimensionState,
    dimensionList,
    addUpdateDimensionState,
    resetAddUpdateDimensionState,
    GetByDimensionIdService,
    DeleteDimensionService,
    deleteDimensionState,
    resetDeleteDimensionState
  } = dimensionStore;

  const { saveProcessOrderState, resetSaveProcessOrderState } =
    activeTrayManagementStore;

  let lang: string;
  const allProcessListData = allDimension;
  const isFirstLoad = useRef(true);
  const [disablePagination, setDisablePagination] = useState<boolean>(false);
  const [selectedRow, setSelectedRow] = useState<any>({});
  const [selectedId, setSelectedId] = useState(0);
  const [openPanel, setOpenPanel] = useState(false);
  const [isFilterCleared, setIsFilterCleared] = useState(true);
  const [columSortOrder, setColumnSortOrder] = useState<IDefaultColumSortOrder>(
    ProcessDefaultSortColumnOrder
  );

  const [filterObj, setFilterObj] = useState<IProcessFilter>(
    ProcessFilterInitialState
  );
  const [isFilterApplied, setIsFilterApplied] = useState<boolean>(false);
  const pageLimitOptions: Array<number> = [10, 20, 50, 100];

  const [pageLimitInfo, setPageLimit] = useState<IPageLimitInfo>({
    pageLimit: userSetting.pageLimitConfig,
    isPageLimitChange: false,
  });

  const [pageInfo, setPageInfo] = useState<IPageInfo>({
    currentPage: 1,
    totalPages: 1,
    isPagerChange: false,
    isRefreshPage: false,
  });

  const onPageChanged = (pageNumber: number) => {
    closePanelHandler();
    setPageInfo({ ...pageInfo, currentPage: pageNumber, isPagerChange: true });
  };

  const setIsRefreshPage = () => {
    setPageInfo({ ...pageInfo, isRefreshPage: false });
  };

  const onPageLimitChanged = (evt: any) => {
    let pages: number;
    pages = props.data && Math.ceil(props.data.length / evt.target.value);
    setPageInfo({
      ...pageInfo,
      currentPage: 1,
      totalPages: pages,
      isPagerChange: false,
    });
    setPageLimit({
      pageLimit: parseInt(evt.target.value),
      isPageLimitChange: true,
    });
    setUserSetting(userSettingEnum.UserLimitConfig, parseInt(evt.target.value));
  };

  const getProcessListServiceHandler = (
    filterQuery?: string,
    isFilter = false
  ) => {
    if (!filterQuery) {
      filterQuery = createQueryString({
        ...filterObj,
        Column: columSortOrder.dataField,
        Order: columSortOrder.order,
      });
    }
    if (!isFilter) {
      GetDimensionListService(
        Number(getTenantIdFromLocalStorage()),
        pageLimitInfo.pageLimit,
        pageInfo.currentPage
        // encodeURIComponent(filterQuery)
      );
    } else {
      GetDimensionListService(
        Number(getTenantIdFromLocalStorage()),
        pageLimitInfo.pageLimit,
        1
        // encodeURIComponent(filterQuery)
      );
    }
  };

  useEffect(() => {
    getProcessListServiceHandler();
  }, []);

  useEffect(() => {
    if (islanguageChanged) {
      updateLanguageChangedFlag();
    }
  }, [islanguageChanged]);
  useEffect(() => {
    setPageInfo({
      ...pageInfo,
      currentPage: dimensionList?.PagingDetails?.CurrentPage ?? 1,
      totalPages: dimensionList?.PagingDetails?.TotalPages ?? 1,
      isPagerChange: false,
    });
    setDisablePagination(false);
  }, [dimensionList]);

  useEffect(() => {
    if (saveProcessOrderState.success) {
      toast.success(formatMessage('updated_success'));
      getProcessListServiceHandler(createQueryString(filterObj));
      resetSaveProcessOrderState();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [saveProcessOrderState.success]);

  useEffect(() => {
    if (pageInfo.isPagerChange) {
      getProcessListServiceHandler();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageInfo.currentPage]);

  useEffect(() => {
    if (pageLimitInfo.isPageLimitChange) {
      getProcessListServiceHandler();
      setPageLimit({ ...pageLimitInfo, isPageLimitChange: false });
    }
  }, [pageLimitInfo.pageLimit]);

  useEffect(() => {
    if (lang && language !== lang) {
      getProcessListServiceHandler();
    }
  }, [language]);

  useEffect(() => {
    if (addUpdateDimensionState.success) {
      resetAddUpdateDimensionState();
      getProcessListServiceHandler();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addUpdateDimensionState.success]);

  useEffect(() => {
    if (deleteDimensionState.success) {
      toast.success(formatMessage('deleted_success'));
      props.deletePopupToggleHandler();
      resetDeleteDimensionState();
      getProcessListServiceHandler();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleteDimensionState.success]);

  useEffect(() => {
    if (saveDimensionDataState.success) {
      resetSaveDimensionDataState();
      getProcessListServiceHandler();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [saveDimensionDataState.success]);

  function rowClassFormat(row: any, rowId: number) {
    let className: string = '';
    if (selectedRow?.Id && row.Id === selectedRow.Id) {
      className = 'bg-row SelectedRow';
    }
    return className;
  }

  const rowEvents = (e: SyntheticEvent, row: any) => {
    // GetProcessByIdService(row.Id);
    setSelectedRow(row);
    if (selectedRow.Id === undefined || selectedRow.Id !== row.Id) {
      setOpenPanel(true);
    } else {
      setOpenPanel(!openPanel);
    }
  };

  const handleProcessReorderSubmit = () => {
    // setTimeout(() => {
    // }, 5000);
  };

  const closePanelHandler = () => {
    setSelectedRow({});
    setOpenPanel(false);
  };

  const refreshClickHandler = () => {
    getProcessListServiceHandler();
    closePanelHandler();
  };

  const deleteHandler = () => {
    DeleteDimensionService(Number(getTenantIdFromLocalStorage()), selectedId);
  };

  const deleteClickHandler = (
    row: any,
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    setSelectedId(row.Id);
    event.stopPropagation();
    closePanelHandler();
    resetProcessDetail();
    props.deletePopupToggleHandler();
  };

  const handleProcessReorderToggleHandler = (e) => {
    props.processReorderToggleHandler();
    // getActiveTrayListServiceHandler(createQueryString(filterObj));
  };

  const addDimensionHandler = (
    row: { Id: number },
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    event.stopPropagation();
    closePanelHandler();
    setSelectedId(row.Id);
    props.addDimensionDataToggleHandler();
  };

  const createQueryString = (filter: IProcessFilter): string => {
    return Object.entries(filter)
      .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
      .join('#');
  };

  const filterHandler = (object: IProcessFilter) => {
    const filters = {
      ...object,
      Column: columSortOrder.dataField,
      Order: columSortOrder.order,
    };
    const filter = createQueryString({ ...filters });
    getProcessListServiceHandler(filter, true);
    setFilterObj({ ...filters });
    props.filterPopupToggleHandler();
    closePanelhandler();
    setIsFilterCleared(false);
  };

  const closePanelhandler = () => {
    setSelectedRow({});
    setOpenPanel(false);
  };

  const filterParams = (obj: IProcessFilter, isfilterCleard: boolean) => {
    const filter = createQueryString({
      ...obj,
      Column: columSortOrder.dataField,
      Order: columSortOrder.order,
    });

    if (isfilterCleard) {
      setFilterObj({ ...obj });
      getProcessListServiceHandler(filter);
      closePanelhandler();
      setIsFilterCleared(true);
    } else {
      setFilterObj({ ...obj });
    }
    props.filterPopupToggleHandler();
  };

  const handleTableChange = (type: any, newState: any) => {
    if (isFirstLoad.current) {
      isFirstLoad.current = false;
      return;
    }

    setColumnSortOrder((prevState) => ({
      ...prevState,
      dataField: newState.sortField,
      order: newState.sortOrder,
    }));
  };

  useEffect(() => {
    const filter = createQueryString({
      ...filterObj,
      Column: columSortOrder.dataField,
      Order: columSortOrder.order,
    });

    getProcessListServiceHandler(filter);
  }, [columSortOrder]);

  const editClickHandler = () => {
    GetByDimensionIdService(Number(getTenantIdFromLocalStorage()), 30);
  };

  const actionIcons: IActionFormatter[] = showIconsRoleBase(
    [
      {
        dataField: 'isEdit',
        handler: addDimensionHandler,
        icon: <EditIcon />,
        // isDisable: !isOperationPermittedRoleBase(
        //   ModuleType.ProcessManagement,
        //   'Edit'
        // ),
        isDisable: false,
        title: 'edit',
        varient: 'primary',
        action: 'edit',
      },
      {
        dataField: 'isDelete',
        handler: deleteClickHandler,
        icon: <DeleteIcon />,
        // isDisable: !isOperationPermittedRoleBase(
        //   ModuleType.ProcessManagement,
        //   'Delete'
        // ),
        isDisable: false,
        title: 'delete',
        varient: 'danger',
        action: 'delete',
      },
      // {
      //   dataField: 'dimensionData',
      //   handler: dimensionDataHandler,
      //   icon: <DimensionIcon />,
      //   // isDisable: !isOperationPermittedRoleBase(
      //   //   ModuleType.ProcessManagement,
      //   //   'Delete'
      //   // ),
      //   isDisable: false,
      //   title: 'dimensionData',
      //   varient: 'btn btn-light-success btn-sm',
      //   action: 'dimensionData',
      // },
    ],
    ModuleType.DimensionTableFields
  );

  const columns: any = [
    {
      dataField: 'serialNumber',
      text: formatMessage('serial_number'),
      classes: 'show-Elipses',
      isDummyField: true,
      formatter: (_: any, __: any, rowIndex: number) => rowIndex + 1,
      sort: false,
    },
    {
      dataField: 'Id',
      text: formatMessage('label_id'),
      classes: 'show-Elipses',
      hidden: true,
    },
    {
      dataField: 'Messages',
      text: formatMessage('messages'),
      classes: 'show-Elipses',
      title: (cell: string) => {
        // return cell.length > 10 ? cell : undefined;
      },
      sort: false,
    },
    // {
    //   dataField: 'MessagesType',
    //   text: formatMessage('messages_type'),
    //   sort: false,
    //   classes: 'show-Elipses',
    //   title: (cell: string) => {
    //     // return cell.length > 10 ? cell : undefined;
    //   },
    // },
    {
      dataField: 'ProcessName',
      text: formatMessage('process_name'),
      sort: false,
      classes: 'show-Elipses',
      title: (cell: string) => {
        return cell && cell.length > 10 ? cell : undefined;
      },
    },

    // {
    //   dataField: 'Comment',
    //   text: formatMessage('comment'),
    //   classes: 'show-Elipses',
    //   title: (cell: string) => {
    //     // return cell.length > 10 ? cell : undefined;
    //   },
    // },
    {
      dataField: '',
      formatter: CustomActionFormatter(actionIcons),
      text: formatMessage('actions'),
      classes: 'last-column',
      hidden: actionIcons.length > 0 ? false : true,
    },
  ];

  return (
    <>
      {/* {props.showAddProcessPopup && (
        <AddProcess
          id={selectedId}
          modalClosed={props.addToggleHandler}
        />
      )} */}
      {props.showDeletePopup && (
        <DeletePopup
          title="delete_dimension"
          modalSubmit={deleteHandler}
          modalClosed={props.deletePopupToggleHandler}
          message="message_delete_dimension_confirm"
          isLoading={deleteDimensionState.inProgress}
        />
      )}
      {props.showAddDimensionDataPopup && (
        <AddDimensionData
          id={selectedId}
          modalClosed={props.addDimensionDataToggleHandler}
        />
      )}
      {props.showReorderProcessPopup && (
        <ProcessReorder
          id={selectedId}
          modalClosed={props.processReorderToggleHandler}
          processOptions={[]}
          onSubmitReorder={handleProcessReorderSubmit}
          isDimension={true}
        />
      )}
      <div className="icon-nav navbar-fixed-top device-nav-bar userTopNav">
        <div className="row align-items-center">
          <Header
            className="col"
            label="dimension_table_fields"
          />
          <div className="col-auto">
            <ul className="add-list">
              {/* <li>
                <FilterComponent
                  initialValues={filterObj}
                  id={0}
                  submitHandler={filterHandler}
                  filterParmas={filterParams}
                  onModalClosed={props.filterPopupToggleHandler}
                  isFilterCleared={isFilterCleared}
                  isLoading={false}
                  isDisable={false}
                  isFilterApplied={isFilterApplied}
                  setIsFilterApplied={setIsFilterApplied}
                />
              </li> */}
              <li title={formatMessage('refresh')}>
                <a
                  data-toggle="modal"
                  className="btn btn-light"
                  onClick={() => refreshClickHandler()}
                >
                  <RefreshIcon />
                </a>
              </li>
              <li
                title={formatMessage('reorder_process')}
                className=""
              >
                <a
                  className="btn btn-primary"
                  data-toggle="modal"
                  data-testid="modalbtn"
                  data-target="#addUser"
                  onClick={handleProcessReorderToggleHandler}
                >
                  {' '}
                  <img
                    src={ReorderProcess}
                    alt=""
                    className="ReorderProcess me-1"
                  />
                  <FormattedMessage id="reorder_process" />
                </a>
              </li>
              {isOperationPermittedRoleBase(
                ModuleType.DimensionTableFields,
                'Add'
              ) && (
                <li
                  title={formatMessage('add_dimension_data')}
                  className="mt-1"
                >
                  <a
                    className="btn btn-secondary"
                    data-toggle="modal"
                    data-testid="modalbtn"
                    data-target="#addUser"
                    onClick={(event: any) =>
                      addDimensionHandler({ Id: -1 }, event)
                    }
                  >
                    <span className="me-1">
                      <PlusIcon />{' '}
                    </span>
                    <FormattedMessage id="add_dimension_data" />
                  </a>
                </li>
              )}
            </ul>
          </div>
        </div>
      </div>
      <div className={`${openPanel ? 'panelOpen' : ''}`}>
        <div className="card card-page">
          {(getDimensionState.inProgress ||
            processState.inProgress ||
            deleteProcessState.inProgress) && (
            <FormLoader
              loading={
                getDimensionState.inProgress ||
                processState.inProgress ||
                deleteProcessState.inProgress
              }
            />
          )}
          {allProcessListData && allProcessListData.length > 0 ? (
            <>
              <div>
                <div className="tableDesign row-eq-height tableDevices p-3 changingPanel">
                  <div
                    className="table-responsive"
                    data-testid="table"
                  >
                    {allProcessListData && (
                      <Grid
                        data={allProcessListData}
                        columns={columns}
                        keyField="Id"
                        loading={false}
                        rowClasses={rowClassFormat}
                        rowEvents={{ onClick: rowEvents }}
                        hover={true}
                        // sort={{ ...columSortOrder }}
                        // remote={{ ...GridRemoteConstant }}
                        // onTableChange={handleTableChange}
                      />
                    )}
                  </div>
                </div>
              </div>
              {allProcessListData.length > 0 ? (
                <div className="row no-gutters p-3 pt-0 tableFooter">
                  <div className="col-lg-3 col-md-6 col-sm-6 pt-1">
                    <FormattedMessage id="show" />
                    <select
                      data-testid="pageSelect"
                      className="pageLimit"
                      onChange={onPageLimitChanged}
                      value={pageLimitInfo.pageLimit}
                    >
                      {pageLimitOptions.map((op: any) => (
                        <option
                          key={op}
                          value={op}
                        >
                          {op}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-lg-9 col-md-6 col-sm-6 d-flex justify-content-sm-end">
                    <Pagination
                      isRefreshPage={false}
                      totalPages={pageInfo.totalPages}
                      pageLimit={pageLimitInfo.pageLimit}
                      onPageChanged={onPageChanged}
                      disablePagination={disablePagination}
                      setIsRefreshPage={setIsRefreshPage}
                      currentPage={pageInfo.currentPage}
                      totalRecords={
                        dimensionList?.PagingDetails?.TotalRecords ?? 0
                      }
                    />
                  </div>
                </div>
              ) : (
                ''
              )}
            </>
          ) : (
            <div className="message">
              <div className="d-flex message-area">
                <div className="no-data-img">
                  <img
                    src={noMessageIcon}
                    alt=""
                    className="no_message"
                  />
                </div>
                <div>
                  <h3 className="fw-bold display-6">
                    {' '}
                    <FormattedMessage id="no_dimension_table" />
                  </h3>
                  <h4 className="mb-3">
                    {formatMessage('no_dimension_table_message')}
                  </h4>
                  {isOperationPermittedRoleBase(
                    ModuleType.DimensionTableFields,
                    'Add'
                  ) && (
                    <>
                      <a
                        className="btn btn-primary"
                        onClick={(event: any) =>
                          addDimensionHandler({ Id: -1 }, event)
                        }
                      >
                        <span className="me-1">
                          <PlusIcon />{' '}
                        </span>
                        <FormattedMessage id="add_dimension_data" />
                      </a>
                    </>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      <SlidingPanel
        type={'right'}
        isOpen={openPanel}
        noBackdrop={false}
        size={100}
      >
        <div className="bg_slide panel">
          <div className="row bb p-2 pl-4 g-0 align-items-center ">
            <div className="col-lg-10 col-md-10 col-sm-10 col-xs-10">
              <h2 className="fw-bold mb-0 mt-1 ms-2 py-2">
                {selectedRow?.Messages}
              </h2>
            </div>
            <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2 close-icon-detail">
              <span title={formatMessage('close')}>
                <CloseSidePanelIcon closePanelHandler={closePanelHandler} />
              </span>
            </div>
          </div>
          <div className="group_detailsWrapper pb-3">
            <DimensionDetails selectedRowId={selectedRow.Id} />
          </div>
        </div>
      </SlidingPanel>
    </>
  );
};

export default ReorderProcessPopupHOC(
  AddDimensionDataPopupHOC(
    FilterPopupHOC(DeletePopupHOC(observer(DimensionTableFields)))
  )
);

// export default ReorderProcessPopupHOC(
//   EditActiveTrayDatePopupHOC(
//     ImportActiveTrayDetailsPopupHOC(
//       FilterPopupHOC(
//         AddEditActiveTrayManagementPopupHOC(
//           DeletePopupHOC(observer(ActiveTrayManagement))
//         )
//       )
//     )
//   )
// );
